var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.toggle}},[_vm._t("button")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("popover")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }